import { isAfter } from 'date-fns';

type Version = {
  id?: string;
  status?: string;
  date_created?: string;
};

export function filterLatestActiveVersions<T extends Version>(versions: T[]) {
  return versions.filter((item, _index, array) => {
    const duplicates = array.filter((other) => other.id === item.id);
    if (item.status !== 'ACTIVE') {
      return false;
    }
    if (duplicates.length === 1) {
      return true;
    }
    let latest = duplicates[0];
    duplicates.forEach((current, index) => {
      if (index === 0) {
        return;
      }
      if (!latest.date_created) {
        latest = current;
        return;
      }
      if (!current.date_created) {
        return;
      }
      if (
        isAfter(new Date(current.date_created), new Date(latest.date_created))
      ) {
        latest = current;
      }
    });
    return latest === item;
  });
}
